<template>
  <div class="home">
    <banner-Component></banner-Component>
   <div class="main">
       <!--       产品中心-->
       <mpro />

<!--       东方极简风格-->
       <div class="fg wow " @click="goto3">
           <img src="../assets/zr/bg.png" alt="">
           <div class="text">
           <p>360°全景展厅</p>
               <span>
                   <i class="iconfont icon-bofang"></i>
               </span>
           </div>
       </div>
<!--       新闻中心-->
       <news />

       <customer  />
   </div>
      <foot-Component class="foot wow fadeIn" ></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import { CountUp } from 'countup.js'
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import footComponent from '../components/foot'
  import mpro from '../components/mpro'
  import news from '../components/news'
  import customer from '../components/customer'
export default {
  name: 'home',
    data(){
      return{
          scrollbar:''
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
        // setTimeout(()=>{
        //     this.count()
        // },100)
    },
  components:{bannerComponent,footComponent,swiper, swiperSlide,mpro,news,customer},
    methods:{
        goto3(){
            window.open('https://720yun.com/t/a2vkuq7h7qe?scene_id=41442687','_blank')
        },
        gotoInfo(n){
            const link=`/newsInfo.html?id=${n}`
            window.open(link,'_blank')
        },
        // getNews(id){
        //     const url = `${getNewsUrl('zh-CN',id,1000,1)}`
        //     this.$axios.get(url).then(res => {
        //         res.data.newsArr.map((item)=>{
        //             item.SHOWTIME=item.SHOWTIME.slice(0,11)
        //             if(item.ISCOMMEND==='1'){
        //                 this.nList.push(item)
        //             }
        //         })
        //     })
        // },
        count(){
            let element=this.$refs.counts;
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (element=element.offsetParent){
                actualTop += element.offsetTop;
                /* current = current.offsetParent; */
            }
            let demoFi1 = new CountUp("num1", 1500);
            let demoFi2 = new CountUp("num2", 7500);
            let demoFi3 = new CountUp("num3", 200);
            // demoFi1.start();
            // demoFi2.start();
            // demoFi3.start();
            let numok=false;
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            if(scrollbar){
                scrollbar.addListener((status) => {
                    if(!numok){
                        if(actualTop<status.offset.y+document.body.clientHeight){
                            demoFi1.start();
                            demoFi2.start();
                            demoFi3.start();
                            numok=true;
                        }
                    }
                });
            }
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        },
        gotoNews(){
            const link='/news.html'
            window.open(link,'_self')
        },
     change(n){
       this.select=n
     }
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
  .main{
    width:100%;
    .fg{
        width:100%;
        position: relative;
        animation: 2s polygon forwards linear;
        img{
            width:100%;
            display: block;
            object-fit: cover;
        }
        .text{
            width:100%;
            text-align: center;
            position: absolute;
            left:0;
            bottom:40%;
            p:nth-child(1){
                font-family: "SourceHanSerifCN-Medium";
                font-size: 26px;
                color:white;
                margin-bottom: 40px;
            }
            span{
                cursor: pointer;
                i{
                    font-size: 50px;
                    color:white;
                }
            }
        }
    }
  }
    .foot{
      animation-duration: 5s;
    }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
        clip-path: polygon(0 0,0 100%,0 100%,0 0);
        opacity: 0;
    }
    100% {
        clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
        opacity: 1;
    }
  }

  @media screen  and (min-width: 2200px){

  }
  @media screen and (max-width: 1440px){
  .main{
   .about{
       width:90%;
       .ln{
           width:100%;
       }
   }
  }
  }
  @media screen and (max-width: 1000px){
      .main{
          .about{
              .content{
                  width:100%;
                  flex-direction: column;
                  .left,.right{
                      width:100%;
                      margin-left: 0;
                     position: static;
                  }
                  .left{
                      .t1{
                          p:nth-child(1){
                              font-size: 24px;
                          }
                      }
                  }
              }
              .ln{
                  .allItems{
                      flex-wrap: wrap;
                      .item{
                          width:33%;
                      }
                  }
              }
          }
      }
  }
}
</style>
